import React, { useCallback } from 'react';
import { Container } from 'react-bootstrap';

import GrnDetailProvider from 'providers/GrnDetailProvider';

import GrnDetailInfo from 'components/purchase-order/grn/GrnDetails/GrnDetailInfo';
import GrnLines from 'components/purchase-order/grn/GrnDetails/GrnLines';

const GrnDetail = () => {
  const handleGRNLineUpdate = useCallback(() => {
    window.dispatchEvent(new CustomEvent('grn-line-updated'));
  }, []);

  return (
    <GrnDetailProvider>
      <Container fluid className="p-0 d-flex flex-column gap-4">
        <GrnDetailInfo listenToUpdates={true} />

        <GrnLines onGRNLineUpdate={handleGRNLineUpdate} />
      </Container>
    </GrnDetailProvider>
  );
};

export default GrnDetail;
